import React from 'react';
import { ArrowUpRightIcon, PlayIcon } from 'lucide-react';
import { tiktokTips } from '../data/site';
export function TikTokTips() {
  return <div className="overflow-hidden rounded-lg border border-black/10 bg-ink" data-id="element-242" data-mp="ncb1q6djv9g8">
      <div className="flex items-start gap-3 px-6 pt-6 lg:px-7 lg:pt-7" data-id="element-243" data-mp="ifcbw00x5onu">
        <TikTokGlyph className="mt-0.5 h-6 w-6 shrink-0 text-white" data-id="element-244" data-mp="edh7unrlsx6d" />
        <div data-id="element-245" data-mp="1b384asjgguet">
          <h3 className="font-display text-[20px] font-bold tracking-tight text-white" data-id="element-246" data-mp="1b2ybyyaxub5y">
            East End Automotive Tips
          </h3>
          <p className="mt-1 text-[13px] font-medium text-chalk/55" data-id="element-247" data-mp="165eyi0m2e2f2">
            {tiktokTips.displayName} · {tiktokTips.handle}
          </p>
        </div>
      </div>

      <p className="px-6 pt-4 text-[14.5px] leading-relaxed text-chalk/75 lg:px-7" data-id="element-248" data-mp="x3yq1yet8adh">
        Quick shop tips from East End so customers know what to watch for
        before a small issue turns into a bigger repair.
      </p>

      <div className="px-6 pb-6 pt-5 lg:px-7 lg:pb-7" data-id="element-249" data-mp="3hsv4ds75e2wh">
        <a href={tiktokTips.videoUrl} target="_blank" rel="noreferrer" aria-label={`Watch on TikTok: ${tiktokTips.caption}`} className="group mx-auto block w-full max-w-[300px] sm:max-w-[320px]" data-id="element-250" data-mp="35pk5ctev10h1">
          <span className="relative block aspect-[9/16] w-full overflow-hidden rounded-lg border border-white/10 bg-charcoal transition-colors duration-150 ease-out group-hover:border-brand/60" data-id="element-251" data-mp="2wodlqbgwz9jk">
            <img src={tiktokTips.thumbnailUrl} alt={`TikTok preview: ${tiktokTips.caption}`} loading="lazy" className="absolute inset-0 h-full w-full object-contain" data-id="element-252" data-mp="2mxj27ev1yo1t" />
            <span className="absolute inset-x-0 top-0 flex items-center justify-between gap-3 p-4" data-id="element-253" data-mp="2hzzbhfh64isz">
              <span className="rounded bg-ink/70 px-2 py-1 text-[11px] font-bold uppercase tracking-[0.14em] text-white" data-id="element-254" data-mp="24081rqxopoks">
                Latest tip
              </span>
              <TikTokGlyph className="h-5 w-5 shrink-0 text-white" data-id="element-255" data-mp="28yjc02rw613j" />
            </span>
            <span className="absolute left-1/2 top-1/2 flex h-16 w-16 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-brand transition-colors duration-150 ease-out group-hover:bg-brand-light" data-id="element-256" data-mp="eknlrxmh0kl8">
              <PlayIcon className="h-7 w-7 fill-white text-white" aria-hidden="true" data-id="element-257" data-mp="5oogmiqkmfal" />
            </span>
          </span>

          <span className="mt-4 block font-display text-[17px] font-bold leading-snug tracking-tight text-white" data-id="element-258" data-mp="xgnj7ny7wgc7">
            {tiktokTips.caption}
          </span>
          <span className="mt-2 block text-[13px] text-chalk/55" data-id="element-259" data-mp="ogqz7zmrw5nh">
            {tiktokTips.handle}
          </span>
          <span className="mt-2 inline-flex items-center gap-1.5 whitespace-nowrap text-[13px] font-bold text-brand-light" data-id="element-260" data-mp="jiyv878ust2x">
            Watch on TikTok
            <ArrowUpRightIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-261" data-mp="3954x1b50sn74" />
          </span>
        </a>

        <a href={tiktokTips.profileUrl} target="_blank" rel="noreferrer" className="mt-5 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-brand px-5 py-3 text-[14px] font-bold text-white transition-colors duration-150 ease-out hover:bg-brand-light" data-id="element-262" data-mp="34ar6bm1az48s">
          <TikTokGlyph className="h-4 w-4 shrink-0" data-id="element-263" data-mp="38t41vmu828rw" />
          Follow us on TikTok
        </a>
      </div>
    </div>;
}
function TikTokGlyph({
  className = ''
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" className={className} data-id="element-264" data-mp="3htsh2kvcqf6d">
      <path d="M16.6 5.82A4.28 4.28 0 0 0 15.54 3h-3.1v12.4a2.6 2.6 0 1 1-1.84-2.49v-3.1a5.7 5.7 0 1 0 4.94 5.65V8.9a7.3 7.3 0 0 0 4.06 1.23V7.03a4.3 4.3 0 0 1-3-1.21Z" data-id="element-265" data-mp="3msvm45bc0lec" />
    </svg>;
}